import Swal from "sweetalert2";
import { t } from "i18next";
import { fetchToken } from "../helpers/fetch";
import { const_routes } from "../helpers/const_routes";
import { types } from "../types/types";
import { startLogout } from "./authActions";

const handleBodyError = (body, dispatch) => {
  if (body.code === "bak-error-001") {
    Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method || ""}`, "error");
  }
  if (body.code === "bak-aut-tok-inv-001") {
    Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
    dispatch(startLogout());
  }
  if (body.code === "bak-aut-tok-inv-002") {
    Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
    dispatch(startLogout());
  }
};

const requestRows = async (route, endpoint, data, method) => {
  const resp = await fetchToken(
    const_routes.SCHEMA,
    const_routes.VERSIONV1,
    route,
    endpoint,
    data,
    method
  );
  return resp.json();
};

export const startLoadingTopicQuestionLists = () => async (dispatch) => {
  const [topicsBody, questionsBody] = await Promise.all([
    requestRows(const_routes.ROUTE_CATALOG_TOPIC, "get"),
    requestRows(const_routes.ROUTE_CATALOG_QUESTION, "get")
  ]);
  if (!topicsBody.ok || !questionsBody.ok) {
    handleBodyError(topicsBody.ok ? questionsBody : topicsBody, dispatch);
    return;
  }
  dispatch({
    type: types.CATALOG_SET_TOPIC_QUESTION_LISTS,
    payload: {
      groups: topicsBody.rows || [],
      concerns: questionsBody.rows || []
    }
  });
};

export const startLoadingCatalogNameRows = (kind) => async (dispatch) => {
  const route = kind === "question" ? const_routes.ROUTE_CATALOG_QUESTION : const_routes.ROUTE_CATALOG_TOPIC;
  const body = await requestRows(route, "get");
  if (!body.ok) {
    handleBodyError(body, dispatch);
    return [];
  }
  return body.rows || [];
};

export const startSavingCatalogNameRow = (kind, payload, id) => async (dispatch) => {
  const route = kind === "question" ? const_routes.ROUTE_CATALOG_QUESTION : const_routes.ROUTE_CATALOG_TOPIC;
  const body = id
    ? await requestRows(route, `update/${id}`, payload, "PUT")
    : await requestRows(route, "add", payload, "POST");
  if (!body.ok) {
    handleBodyError(body, dispatch);
    return false;
  }
  return true;
};

export const startDeletingCatalogNameRow = (kind, id) => async (dispatch) => {
  const route = kind === "question" ? const_routes.ROUTE_CATALOG_QUESTION : const_routes.ROUTE_CATALOG_TOPIC;
  const body = await requestRows(route, `delete/${id}`, {}, "DELETE");
  if (!body.ok) {
    handleBodyError(body, dispatch);
    return false;
  }
  return true;
};
